export const createCancelScheduledValuesAutomationEvent = (cancelTime) => {
    return { cancelTime, type: 'cancelScheduledValues' };
};
//# sourceMappingURL=create-cancel-scheduled-values-automation-event.js.map